import React from "react";

export default function BestieGuide({ userName }) {

const AUDIENCE_FIT = [
  { audience: "🐣 Preschool & Families", ratings: { bestie: 3, purpleDoor: 2, pulse: 2, lifeReplay: 1, growthLoop: 3 } },
  { audience: "👩 Parents",              ratings: { bestie: 2, purpleDoor: 3, pulse: 3, lifeReplay: 2, growthLoop: 3 } },
  { audience: "⚡ Gen Z & Alpha",         ratings: { bestie: 3, purpleDoor: 3, pulse: 3, lifeReplay: 2, growthLoop: 3 } },
  { audience: "🌍 Everyone",              ratings: { bestie: 2, purpleDoor: 3, pulse: 3, lifeReplay: 3, growthLoop: 3 } },
];

const APPS = [
  { key: "bestie", icon: "🧸", label: "Bestie" },
  { key: "purpleDoor", icon: "🟣", label: "PurpleDoor" },
  { key: "pulse", icon: "💓", label: "Pulse" },
  { key: "lifeReplay", icon: "🎬", label: "LifeReplay" },
  { key: "growthLoop", icon: "♾️", label: "GrowthLoop" },
];

const stars = (n) => "⭐".repeat(n);
  return (
    <div className="bg-slate-950 text-white rounded-xl border border-cyan-500 p-6">
      <h2 className="text-xl lg:text-2xl lfont-bold">🧸 Bestie Guide</h2>

      <p className="text-xs lg:text-sm text-slate-300 mb-6">
        Hi {userName}! Welcome to your fun corner of Think5Whys.
      </p>

      <div className="space-y-4">
        <div className="rounded-lg bg-slate-900 p-4">
          <div className="text-sm lg:text-lg font-semibold">🚘 CrashLanes</div>
          <div className="text-xs lg:text-sm text-slate-300">
            Improve focus, reflexes and quick decisions.
          </div>
        </div>

        <div className="rounded-lg bg-slate-900 p-4">
          <div className="text-sm lg:text-lg font-semibold">👾 Alien Swarm</div>
          <div className="text-xs lg:text-sm text-slate-300">
            Train attention and reaction speed while having fun.
          </div>
        </div>

        <div className="rounded-lg bg-slate-900 p-4">
          <div className="text-sm lg:text-lg font-semibold">🧠 IQ Tester</div>
          <div className="text-xs lg:text-sm text-slate-300">
            Discover how you think through engaging IQ challenges.
          </div>
        </div>

        <div className="rounded-lg bg-slate-900 p-4">
          <div className="text-sm lg:text-lg font-semibold">🐣 TinyThink</div>
          <div className="text-xs lg:text-sm text-slate-300">
            Brain games for preschoolers and joyful parent-child moments.
          </div>
        </div>

        <div className="rounded-lg bg-slate-900 p-4">
          <div className="text-sm lg:text-lg font-semibold">🦋 WonderEmoji</div>
          <div className="text-xs lg:text-sm text-slate-300">
            Unimaginable world of Imaginable Emojis.
          </div>
        </div>

        <div className="rounded-lg bg-slate-900 p-4">
          <div className="text-sm lg:text-lg font-semibold">𖥂 DroneDash</div>
          <div className="text-xs lg:text-sm text-slate-300">
            Fly, dodge, and dash through obstacles to sharpen coordination and
            reflexes.
          </div>
        </div>
        <div className="rounded-lg bg-slate-900 p-4">
          <div className="text-sm lg:text-lg font-semibold">
            🍬 GumballHistory
          </div>
          <div className="text-xs lg:text-sm text-slate-300">
            One place for all your points — past, present, and future games, all
            counted together.
          </div>
        </div>
        <div className="rounded-lg bg-slate-900 p-4">
          <div className="text-sm lg:text-lg font-semibold">⭐ FanRatings</div>
          <div className="text-xs lg:text-sm text-slate-300">
            See how you rank, category by category, based on your daily
            engagement.
          </div>
        </div>
        <div className="rounded-lg bg-slate-900 p-4">
          <div className="text-sm lg:text-lg font-semibold">🎡 QuickSpin</div>
          <div className="text-xs lg:text-sm text-slate-300">
            Spin the wheel and let luck crown today's winner — with a few
            dynamic twists.
          </div>
        </div>
        <div className="rounded-lg bg-slate-900 p-4 opacity-70">
          <div className="text-sm lg:text-lg font-semibold">
            💜 AICricketLeague
          </div>
          <div className="text-xs lg:text-sm text-slate-300">
            An AI-powered cricket strategy league — coming soon in a future
            release.
          </div>
        </div>
      </div>

      <div className="mt-4 rounded-xl bg-gradient-to-r from-cyan-950/40 to-purple-950/40 border border-cyan-700 p-4 lg:p-6">
        <h3 className="text-sm lg:text-lg font-bold text-cyan-300 mb-4">
          🌱 Why all these?
        </h3>

        <div className="grid grid-cols-2 gap-3 lg:gap-6">
          <div className="rounded-lg bg-slate-900/70 p-3">
            <div className="text-lg lg:text-2xl">🧠</div>
            <div className="font-semibold text-sm lg:text-lg">Think Better</div>
            <div className="text-[11px] lg:text-sm text-slate-300">
              Focus • Logic • Memory • Creativity
            </div>
          </div>

          <div className="rounded-lg bg-slate-900/70 p-3">
            <div className="text-lg lg:text-2xl">❤️</div>
            <div className="font-semibold text-sm lg:text-lg">Live Better</div>
            <div className="text-[11px] lg:text-sm text-slate-300">
              Habits • Wellbeing • Reflection • Growth
            </div>
          </div>

          <div className="rounded-lg bg-slate-900/70 p-3">
            <div className="text-lg lg:text-2xl">🎮</div>
            <div className="font-semibold text-sm lg:text-lg">Fun First</div>
            <div className="text-[11px] lg:text-sm text-slate-300">
              Learn naturally through play.
            </div>
          </div>

          <div className="rounded-lg bg-slate-900/70 p-3">
            <div className="text-lg lg:text-2xl">🌱</div>
            <div className="font-semibold text-sm lg:text-lg">Grow Daily</div>
            <div className="text-[11px] lg:text-sm text-slate-300">
              Tiny improvements become lifelong transformation.
            </div>
          </div>
        </div>

        <div className="mt-4 text-center">
          <div className="text-sm lg:text-lg font-semibold text-cyan-300">
            🧸 Bestie is the fun beginning...
          </div>

          <div className="mt-2 text-sm lg:text-lg">
            🧸 Bestie
            <span className="mx-2">➡️</span>
            🟣 PurpleDoor
            <span className="mx-2">➡️</span>
            💓 Pulse
            <span className="mx-2">➡️</span>
            🎬 LifeReplay
            <span className="mx-2">➡️</span>
            ♾️ GrowthLoop
          </div>

          <div className="mt-2 text-[11px] lg:text-sm text-slate-400">
            Play → Practice → Understand → Reflect → Transform
          </div>
        </div>
      </div>

      <div className="mt-4 rounded-xl bg-slate-900 border border-cyan-700 p-4">
        <h3 className="text-sm lg:text-lg font-bold text-cyan-300 mb-4">
          🎯 Who is it for?
        </h3>

        {/* Mobile */}
        <div className="lg:hidden space-y-3">
          {AUDIENCE_FIT.map((row) => (
            <div
              key={row.audience}
              className="rounded-xl bg-slate-900 border border-cyan-700 p-3"
            >
              <div className="text-cyan-300 font-bold text-sm mb-2">
                {row.audience}
              </div>
              <div className="space-y-2 text-xs">
                {APPS.map((app) => (
                  <div key={app.key} className="flex justify-between">
                    <span>
                      {app.icon} {app.label}
                    </span>
                    <span>{stars(row.ratings[app.key])}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
          <div className="text-center text-[11px] text-slate-400">
            ⭐⭐⭐ Primary • ⭐⭐ Great Fit • ⭐ Optional
          </div>
        </div>

        {/* Desktop */}
        <div className="hidden lg:block overflow-x-auto">
          <table className="w-full text-[10px] lg:text-sm text-center p-1">
            <thead>
              <tr className="border-b border-cyan-700">
                <th className="text-left text-[10px]">👤</th>
                {APPS.map((app) => (
                  <th key={app.key} className="text-[10px]">
                    {app.icon}
                    <br />
                    {app.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {AUDIENCE_FIT.map((row, i) => (
                <tr
                  key={row.audience}
                  className={
                    i < AUDIENCE_FIT.length - 1
                      ? "border-b border-slate-700"
                      : ""
                  }
                >
                  <td className="text-left p-1 font-semibold text-[10px]">
                    {row.audience}
                  </td>
                  {APPS.map((app) => (
                    <td key={app.key} className="text-[10px]">
                      {stars(row.ratings[app.key])}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-3 text-[10px] sm:text-xs lg:text-sm text-slate-400">
          ⭐⭐⭐ Primary • ⭐⭐ Great Fit • ⭐ Optional
        </div>
      </div>

      <div className="mt-4 rounded-xl bg-cyan-950/40 border border-cyan-700 p-5">
        <h3 className="text-sm lg:text-lg font-semibold text-cyan-300 mb-4">
          🌱 Your Think5Whys Journey
        </h3>

        <div className="text-sm lg:text-lg text-center space-y-2">
          {/* <div>🧸 Bestie</div> */}
          {/* <div>⬇️</div> */}
          <div>🟣 PurpleDoor</div>
          <div className="text-sm text-slate-300">Daily smart actions</div>

          <div>💓 Pulse</div>
          <div className="text-sm text-slate-300">
            Track emotions & wellbeing
          </div>

          <div>🎬 LifeReplay</div>
          <div className="text-sm text-slate-300">Reflect on experiences</div>

          <div>♾️ GrowthLoop</div>
          <div className="text-sm text-slate-300">
            Watch out behaviour and find if area of improvements every day in
            Kids
          </div>
        </div>
      </div>
    </div>
  );
}
